import React from 'react'

import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { FieldLabel } from '@cash-design-system/react'

import { getConfirmationCodeFormat } from '../util'
import { FormMaskedInput } from './FormMaskedInput'

export function ConfirmationCodeInput(): React.ReactElement {
  const { t } = useTranslation()
  const { watch } = useFormContext()

  const watchCode = watch('code') || ''

  const codeFormat = getConfirmationCodeFormat(watchCode)

  return (
    <FieldLabel label={t('Confirmation code', { context: 'label for form field asking for confirmation code' })}>
      <FormMaskedInput
        autoFocus
        name="code"
        placeholder={t('Code', { context: 'placeholder text for form field asking for confirmation code' })}
        format={codeFormat}
        rules={{
          required: {
            value: true,
            message: t('Enter a confirmation code.', { context: 'error message for not entering a confirmation code' }),
          },
        }}
      />
    </FieldLabel>
  )
}
